

exports.__esModule = true;
exports.$ULoginModel = exports.$AuthModel = exports.$AuthApi = undefined;

var _squid = require('squid');

var $AuthApi = exports.$AuthApi = _squid.$Model.extend('$AuthApi', {
    api: new _squid.$Api({
        uri: '/api/auth',
        postAttempts: 3
    })
});

var $AuthModel = exports.$AuthModel = _squid.$Model.extend('$AuthModel', {
    api: new _squid.$Api({
        uri: '/api/auth',
        postAttempts: 3
    }),

    invalidateOnLogout: true, // invalidate this model when auth.logout() gets called

    loggedIn: function loggedIn() {
        return this.logged_in;
    },

    visitorId: function visitorId() {
        return this.visitor_id;
    },

    accessToken: function accessToken() {
        return this.access_token;
    },

    accessTokenPresent: function accessTokenPresent() {
        return this.access_token_present;
    },

    refreshToken: function refreshToken() {
        return this.refresh_token;
    },

    rememberedOT: function rememberedOT() {
        return this.remembered && this.remembered_device_token;
    },

    logout: function logout() {
        _squid.$Model.bulkInvalidate('invalidateOnLogout');
        return this.action('logout');
    },

    clearCookies: function clearCookies() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return this.action('clearCookies', { data: data });
    }

});

var $ULoginModel = exports.$ULoginModel = _squid.$Model.extend('$ULoginModel', {
    api: new _squid.$Api({
        uri: '/api/auth/ulogin',
        postAttempts: 1,
        cache: false
    })
});

angular.value("$AuthApi", $AuthApi);
angular.value("$AuthModel", $AuthModel);
angular.value("$ULoginModel", $ULoginModel);
_squid.$Model;

_squid.$Api;


//////////////////
// WEBPACK FOOTER
// ./components/xo-models/src/auth/index.js
// module id = ./components/xo-models/src/auth/index.js
// module chunks = 1